"use strict";
import React, {useEffect, useState} from "react";
import {startLoadingSpinner, stopLoadingSpinner} from "../../csf-ufc-pivotal/includes/utils";
import {resetErrMessages, removeErrFromValidItems} from '../includes/utils';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import PropTypes from "prop-types";
import JustValidate from 'just-validate';

export function CsfFournisseurListModal({apiUrl, apiEnv, accessToken, listId}) {

  const [listName, setListName] = useState("");
  const [isError, setIsError] = useState(false);
  const [validator, setValidator] = useState(null);

  const errorMessages = {
    '#List_Name': window.Drupal.t('fournisseur.creation_form.validation.required')
  };

  /*
  * Setup form validation
  * */
  useEffect(() => {
    const validator = new JustValidate('#createTrainersList');
    setValidator(validator);

    validator
      .addField('#List_Name', [
        {
          rule: 'required',
        },
      ])
  }, []);

  function handleOnChangeValues(event) {
    let eventValue = event.target.value;
    setListName(eventValue);
  }

  function handleCreateList(e) {
    e.preventDefault();

    validator.revalidate();
    setTimeout(() => {
      resetErrMessages();
      if (validator?.isValid) {  // Check if form is valid
        startLoadingSpinner();
        const requestData = {
          form: "CSF_EP_UXContact_List_REST",
          deltaData: {List_Name : listName}
        };
        if (listId !== '') {
          requestData.recordId = listId;
        }
        const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
        pivotalFormApi.callFormPutEndpoint(requestData, "_Espace_Partenaire")
          .then(response => {
            stopLoadingSpinner();
            if (response?.success) {
              $("[data-dismiss=modal]").trigger({ type: "click" });
               window.location.reload();
            }else{
              setIsError(true);
            }
          })
          .catch(error => {
            setIsError(true);
            stopLoadingSpinner();
            console.error(error);
          });

      } else {
        console.error('Form validation failed!');
        validator.showErrors(errorMessages);
        removeErrFromValidItems();
      }
    });
  }

  function resetModal() {
    document.getElementById('List_Name').value = "";
  }

  return (
    <div className="modal fade" id="createTrainersList" tabIndex="-1" role="dialog" aria-labelledby="editFormateurLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="editFormateurLabel">
              {listId === '' ? (
                window.Drupal.t('fournisseur.gestion.create.modal.title')
              ) : (
                 window.Drupal.t('fournisseur.gestion.listing.detail.rename')
              )}
            </h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')} onClick={resetModal}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <form id="handleCreateList" method="post" onSubmit={handleCreateList}>
            <div className="modal-body">
              {isError === true && (
                <div className="alert alert-danger" role="alert" aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
              )}

              <div className="form-group">
                <label htmlFor="List_Name">{window.Drupal.t('fournisseur.gestion.create.modal.field.label')}*</label>
                <input onChange={handleOnChangeValues} value={listName}
                 type="text" id="List_Name" name="List_Name"/>
              </div>
            </div>

            <div className="modal-footer">
              <div className="space-between-wrapper">
                <button type="button" className='button btn-outlined btn-larger' data-dismiss="modal" onClick={resetModal}>{window.Drupal.t('fournisseur.cancel.btn')}</button>
                <input className="button btn-submit btn-larger" type="submit" value={listId === '' ? window.Drupal.t('fournisseur.gestion.create.modal.btn') : window.Drupal.t('fournisseur.gestion.create.edit.modal.btn')}/>
              </div>
            </div>

          </form>

        </div>
      </div>
    </div>
  );
}

CsfFournisseurListModal.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  accessToken: PropTypes.string,
  listId: PropTypes.string,
};
